import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { Bell, FileText, LogOut, ExternalLink, GraduationCap, Trophy } from "lucide-react";
import { clearToken } from "./adminApi";

const navItems = [
  { to: "/admin/notifications", label: "Job Notifications", icon: Bell },
  { to: "/admin/blogs", label: "Blog Posts", icon: FileText },
  { to: "/admin/gallery", label: "Gallery", icon: Trophy },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const logout = () => {
    clearToken();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-slate-50 flex">
      {/* Sidebar */}
      <aside className="w-60 bg-vedanti-navy text-white flex flex-col fixed inset-y-0 left-0 z-40">
        <div className="px-5 py-5 border-b border-white/10">
          <Link to="/admin/notifications" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-vedanti-orange to-vedanti-mango flex items-center justify-center">
              <GraduationCap size={18} className="text-white" />
            </div>
            <div>
              <p className="font-heading font-bold text-sm leading-tight">Vedanti Admin</p>
              <p className="text-[11px] text-slate-400">Content Manager</p>
            </div>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1" data-testid="admin-nav">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold transition-all ${
                  isActive ? "bg-vedanti-orange text-white" : "text-slate-300 hover:bg-white/10"
                }`
              }
              data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Icon size={17} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold text-slate-300 hover:bg-white/10 transition-all"
          >
            <ExternalLink size={17} /> View Website
          </a>
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold text-red-300 hover:bg-red-500/20 transition-all"
            data-testid="admin-logout-btn"
          >
            <LogOut size={17} /> Logout
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 ml-60 p-6 md:p-8">
        <Outlet />
      </main>
    </div>
  );
}
